import React from 'react';
import { useResponsive } from '../hooks/useResponsive';
import './FifaCard.css';

interface UserStats {
  totalGoals: number;
  totalAssists: number;
  totalSaves: number;
  totalMatches: number;
  totalWins: number;
  totalLosses: number;
}

interface User {
  id: string;
  name: string;
  email: string;
  position?: string;
  rating: number;
  preferredFoot?: 'Derecho' | 'Izquierdo' | 'Ambos';
  preferredPosition?: string;
  avatar?: string;
}

interface FifaCardProps {
  user: User;
  stats: UserStats | null;
}

export const FifaCard: React.FC<FifaCardProps> = ({ user, stats }) => {
  const getPositionAbbreviation = (position: string) => {
    switch (position) {
      case 'Arquero': return 'GK';
      case 'Defensor': return 'DEF';
      case 'Mediocampista': return 'MID';
      case 'Delantero': return 'ST';
      default: return 'ST';
    }
  };

  const getPreferredPositionAbbreviation = (position: string) => {
    switch (position) {
      case 'Arquero': return 'ARQ';
      case 'Defensor': return 'DEF';
      case 'Mediocampista': return 'MC';
      case 'Delantero': return 'DEL';
      default: return 'MC';
    }
  };

  const preferredPosition = getPreferredPositionAbbreviation(user.preferredPosition || user.position || 'Mediocampista');

  // Convertir estrellas a rating FIFA
  const convertStarsToRating = (stars: number) => {
    switch (stars) {
      case 1: return 50;
      case 2: return 60;
      case 3: return 70;
      case 4: return 80;
      case 5: return 90;
      default: return 70; // Valor por defecto si no hay estrellas
    }
  };

  const rating = convertStarsToRating(user.rating);

  return (
    <div className="fifa-card-outer">
      <div id="card" className="fifa-card" style={{
        borderRadius: '20px',
        overflow: 'hidden',
        position: 'relative'
      }}>
        <div id="card-inner">
          <div id="card-top">
            <div className="info">
              <div className="value">{rating}</div>
              <div className="position">{preferredPosition}</div>
              <div className="preferred-foot" style={{
                fontSize: '14px',
                color: '#B0BEC5',
                marginTop: '4px',
                fontWeight: '600'
              }}>
                🦶 {user.preferredFoot || 'Derecho'}
              </div>
            </div>
            <div className="image" style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              {user.avatar && user.avatar.length > 0 ? (
                <div 
                  className="fifa-card-profile-image"
                  style={{
                    backgroundImage: `url(${user.avatar})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                  }}
                />
              ) : (
                <div 
                  className="fifa-card-default-avatar"
                  style={{
                    backgroundImage: 'url(/playericon2.jpeg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                  }}
                />
              )}
            </div>
          </div>
          <div id="card-bottom">
            <div className="name">{user.name}</div>
            <div className="stats" style={{ marginTop: '0' }}>
              <div>
                <ul>
                  <li><span>{stats?.totalMatches ?? 0}</span><span>Partidos</span></li>
                  <li><span>{stats?.totalWins ?? 0}</span><span>Ganados</span></li>
                  <li><span>{stats?.totalLosses ?? 0}</span><span>Perdidos</span></li>
                </ul>
              </div>
              <div>
                <ul>
                  <li><span>{stats?.totalGoals ?? 0}</span><span>Goles</span></li>
                  <li><span>{stats?.totalAssists ?? 0}</span><span>Asistencias</span></li>
                  <li><span>{stats?.totalSaves ?? 0}</span><span>Atajadas</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 